var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M281.6,260.051h-51.2c-4.719,0-8.533-3.823-8.533-8.533c0-4.71,3.814-8.533,8.533-8.533h51.2 c4.719,0,8.533,3.823,8.533,8.533C290.133,256.228,286.319,260.051,281.6,260.051"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M255.991,192.001c-15.556,0-31.113-2.773-45.918-8.329l-29.175-11.025 c-4.403-1.664-6.63-6.588-4.966-10.999c1.664-4.403,6.613-6.622,10.999-4.966l29.15,11.017c25.754,9.66,54.11,9.651,79.863-0.009 l29.124-11.008c4.386-1.673,9.327,0.555,10.999,4.966c1.664,4.412-0.563,9.335-4.966,10.999l-29.15,11.017 C287.121,189.219,271.556,192.001,255.991,192.001"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M25.6,260.051H8.533c-4.719,0-8.533-3.823-8.533-8.533c0-4.71,3.814-8.533,8.533-8.533H25.6 c4.719,0,8.533,3.823,8.533,8.533C34.133,256.228,30.319,260.051,25.6,260.051"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDC3C7"
    },
    d: "M503.467,260.051H486.4c-4.719,0-8.533-3.823-8.533-8.533c0-4.71,3.814-8.533,8.533-8.533h17.067 c4.719,0,8.533,3.823,8.533,8.533C512,256.228,508.186,260.051,503.467,260.051"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M119.017,362.451L119.017,362.451c-51.593,0-93.414-41.822-93.414-93.414v-26.052 c0-33.323,17.698-61.525,46.481-78.319c34.551-20.156,77.286-20.156,111.829,0c28.791,16.794,46.49,44.996,46.49,78.319v8.533 C230.403,313.035,180.534,362.451,119.017,362.451"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4860"
    },
    d: "M59.733,254.134c-4.719,0-8.533-3.823-8.533-8.533c0-24.124,12.945-46.66,33.783-58.82 c4.079-2.372,9.301-0.998,11.665,3.072c2.372,4.07,1.007,9.293-3.063,11.665c-15.616,9.114-25.318,26.001-25.318,44.083 C68.267,250.311,64.452,254.134,59.733,254.134"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M392.983,362.451L392.983,362.451c51.593,0,93.414-41.822,93.414-93.414v-26.052 c0-36.258-17.698-61.525-46.481-78.319c-34.551-20.156-77.286-20.156-111.829,0c-28.791,16.794-46.49,44.996-46.49,78.319v8.533 C281.597,313.035,331.466,362.451,392.983,362.451"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/glasses.b29a70795f26731314c45ac08ef76b7c.svg";
export { ForwardRef as ReactComponent };